var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"between item"},[(_vm.hasNotificationPermission)?_c('a-alert',{attrs:{"message":"您已允许此浏览器为您发送通知信息！","type":"success","show-icon":""}}):_vm._e(),(_vm.hasNotificationPermission === false)?_c('a-alert',{attrs:{"message":"您已拒绝此浏览器为您发送通知信息！如需此功能，请至浏览器设置页面进行设置！","type":"error","show-icon":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }